
export const validationInput = (validationObject) => {
    const { componentType, value, validationRules } = validationObject;
    
    let tierProcessor = null;
    switch (componentType) {
        case 'tier2' :
            tierProcessor = tier2ValidationProcessor;
            break;
        case 'tier1' :
        default :
            tierProcessor = tier1ValidationProcessor;

    }

    //setting by default input to be valid
    let validity = {
        isValid: true
    };

    for(let validationRule in validationRules) {
        validity = tierProcessor(validationRules[validationRule], value, validationObject.maskChar);
        if (!validity.isValid) {
            break;
        }
    }

    return validity;

}

const tier1ValidationProcessor = (validationRule, inputValue) => {
    return checkValidity(inputValue, validationRule);
}

const tier2ValidationProcessor = (validationRule, inputValue, maskChar = '_') => {
    // replacing masked character from the input
    const trimmedValue = inputValue ? inputValue.indexOf(maskChar) !== -1 && typeof inputValue.replaceAll === 'function' ? inputValue.replaceAll(maskChar, '') : inputValue : undefined;
        
    return checkValidity(trimmedValue, validationRule);
}

const checkValidity = (inputValue, rule) => {

    let isValid = true;
    let message = null;
    
    switch (rule.name) {
        case 'required':
            // check for input should not be empty
            isValid = !(inputValue===undefined || inputValue === null || inputValue === "")  && isValid;
            break;
        case 'minLength':
            // Input length should not be less than allowed limit check
            isValid = inputValue.length >= rule.value && isValid;
            message = !isValid & message===null?"Min "+rule.value+" characters required":message;
            break;
        case 'maxLength':
            // Input length should not exceed allowed limit check
            isValid = inputValue.length <= rule.value && isValid;
            message = !isValid & message===null?"Max "+rule.value+" characters allowed":message;
            break;
        case 'nospace':
            isValid = (inputValue.indexOf(' ')<0) && isValid;
            // No spaces allowed check
            message = !isValid & message===null?"No spaces allowed":message;
            break;
        case 'specialchar':
            // check if the input value contains only allowed Special characters
            rule.value.map(char => {
                return isValid = (inputValue.indexOf(char)<0) && isValid;
            });
            message = !isValid & message===null?"Contains invalid special characters":message;
            break;
        case 'restrictFuture':
            // Date entered should not be greater than present date
            const target = (new Date(inputValue)).setHours(0,0,0,0);
            const today = (new Date()).setHours(0,0,0,0);
            isValid = target <= today && isValid;
            message = !isValid & message === null ? inputValue.indexOf("_")===-1? "Future date not allowed":"Invalid Date" : message;
            break;              
        default:
            break;
    }

    return {isValid: isValid, message: message};
}
